
import {CompanySearch, ContactSearch} from 'components/search-dropdown'

export default {
  components: {ContactSearch, CompanySearch},
  emits: ['submit'],
  data() {
    return {
      user_id: undefined,
      chosen_company: undefined,
      chosen_contact: undefined,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return !!this.chosen_company && !!this.chosen_contact
    }
  },
  methods: {
    open(user_id){
      this.chosen_company = undefined
      this.chosen_contact = undefined
      this.user_id = user_id
      this.loading = false
      this.$refs.modal.open()
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
      this.user_id = undefined
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        chosen_company: this.chosen_company,
        chosen_contact: this.chosen_contact,
      })
    }
  }
}
